import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import CloudDownloadIcon from '@material-ui/icons/CloudDownloadRounded';
import CloudDoneIcon from '@material-ui/icons/CloudDoneRounded';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import Avatar from '@material-ui/core/Avatar';

import loaderIcon from'../images/ftc_logo.gif';
import CircularProgress from '@material-ui/core/CircularProgress';



const styles = theme => ({
  card: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    maxWidth: 300,
    height: 50,
    marginTop: 20,
    marginLeft: 20,
    marginBottom: 20,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  chip: {
    margin: theme.spacing.unit,
  },
});

function renderLogo(logo, classes) {
  return(

    <CardMedia
      className={classes.cover}
      image={logo}
      title=""
    />


  )
}
function TripsCard(props) {
  const { classes, theme, title, subtitle, description, logo, colour} = props;
  console.log('LOGO: ', logo);
  return (
    <Card className={classes.card} style={{ backgroundColor: colour}}>
    {logo &&
      <div className={classes.cover}>
      <img src={logo} height='52px'/>
    </div>
    }
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography variant="headline" color="textPrimary">{title}</Typography>
          <Typography variant="subheading" color="textPrimary">
            {subtitle}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {description}
          </Typography>
        </CardContent>
        <div className={classes.controls}>
        </div>
      </div>

    </Card>
  );
}

TripsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TripsCard);



// WEBPACK FOOTER //
// ./src/containers/TripsCard.js